<script setup>
const modifierClass = useGridModifier();
</script>

<template>
  <div
    class="ui-grid-columns-inner"
    :class="`ui-grid-columns-inner--${modifierClass}`"
  >
    <slot name="1" />
    <slot name="2" />
  </div>
</template>

<style scoped lang="scss">
.ui-grid-columns-inner {
  @include media-breakpoint-up(sm) {
    @include grid-columns-base($grid-type: inner);
  }

  $grid-data: map-get(map-get($grids, default), inner);

  @each $type, $area in map-get($grid-data, template-areas) {
    &--#{$type} {
      @include media-breakpoint-up(sm) {
        @include grid-columns($grid-type: inner, $area-id: $type);
      }
    }
  }
}
</style>
